import { render, staticRenderFns } from "./CarouselArrow.vue?vue&type=template&id=579ac000&"
import script from "./CarouselArrow.ts?vue&type=script&lang=ts&"
export * from "./CarouselArrow.ts?vue&type=script&lang=ts&"
import style0 from "./CarouselArrow.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports